import React from "react";
import AlertModal from "../../components/AlertModal";
import useProfileData from "./hooks/useProfileData";
import { getResponsiveStyles, getHoverStyles, getDefaultStyles } from "./utils/profileStyles";
import ProfileHeader from "./components/ProfileHeader";
import DetailsTab from "./components/DetailsTab";
import PerformanceTab from "./components/PerformanceTab";
import ProjectsTab from "./components/ProjectsTab";
const ProfilePage = () => {
  const {
    theme, language, isRTL, t,
    screenSize,
    profilePicture, isUploading,
    activeTab,
    alertModal, closeAlert,
    fileInputRef,
    handleFileSelect, triggerFileInput,
    employeeData, performanceData, recentActivities,
  } = useProfileData();

  const styles = getResponsiveStyles(theme, screenSize, isRTL);

  // ── Shared hover handlers ──────────────────────────────────────────────────
  const handleMouseEnter = (e) => {
    if (!screenSize.isMobile) Object.assign(e.currentTarget.style, getHoverStyles(theme));
  };
  const handleMouseLeave = (e) => {
    if (!screenSize.isMobile) Object.assign(e.currentTarget.style, getDefaultStyles(theme));
  };

  // ── Helper translators passed down as props ────────────────────────────────
  const getProjectStatus = (status) => ({
    Completed:   t("projectCompleted"),
    "In Progress": t("projectInProgress"),
    Planning:    t("projectPlanning"),
  }[status] ?? status);

  const getMetricLabel = (key) => ({
    productivity: t("productivity"),
    collaboration: t("collaboration"),
    innovation:   t("innovation"),
    leadership:   t("leadership"),
  }[key] ?? key);

  // ── Shared props passed to every tab ──────────────────────────────────────
  const sharedProps = { styles, theme, isRTL, screenSize, handleMouseEnter, handleMouseLeave, t };

  return (
    <div style={styles.container}>
      <div style={styles.mainContent}>

        <ProfileHeader
          {...sharedProps}
          language={language}
          profilePicture={profilePicture}
          isUploading={isUploading}
          employeeData={employeeData}
          fileInputRef={fileInputRef}
          triggerFileInput={triggerFileInput}
          handleFileSelect={handleFileSelect}
        />

        {activeTab === "details" && (
          <DetailsTab
            {...sharedProps}
            employeeData={employeeData}
            recentActivities={recentActivities}
          />
        )}

        {activeTab === "performance" && (
          <PerformanceTab
            {...sharedProps}
            performanceData={performanceData}
            getMetricLabel={getMetricLabel}
          />
        )}

        {activeTab === "projects" && (
          <ProjectsTab
            {...sharedProps}
            employeeData={employeeData}
            getProjectStatus={getProjectStatus}
          />
        )}

      </div>

      <AlertModal
        open={alertModal.open}
        title={alertModal.title}
        message={alertModal.message}
        variant={alertModal.variant}
        onClose={closeAlert}
        theme={theme === "dark" ? "dark" : "light"}
        language={language}
      />
    </div>
  );
};

export default ProfilePage;